module.exports = __webpack_public_path__ + "static/media/frame11.51fd76c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-bottom/frame11.png
// module id = 84
// module chunks = 0